<script>
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import LocationModal from "./LocationModal.svelte";
    import {flip} from 'svelte/animate';
    import {copyObject, copyObjectData} from "../lib/lib";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import LocationIcon from "../components/icons/LocationIcon.svelte";
    import LocationLocalPrices from "./LocationLocalPrices.svelte";
    import {LOCATION_TYPE} from "../lib/constants";

    let regions = null;
    let startPoints = null;
    let locations = null;
    let selectedId = 0;
    let editId = null;
    let regionId = 0;
    let region = null;
    let initialized = false;
    let hovering = false;
    let localPriceId = null;
    let localLocation = null;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE LOCATION', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const load = () => {
        const onSuccess = result => {
            regions = result.filter(x => x.level == 0);

            // if (!regionId) {
            //     regionId = regions[0].id;
            // }

            startPoints = result.filter(x => x.is_start_point == 1);
            locations = result.filter(x => x.level == 1);
            initialized = true;
        }

        const onFailure = err => {
        };

        R.handle(R.location.index, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    const saveOrder = () => {
        const onSuccess = result => {
        }

        const onFailure = err => {
            Notifier.showError("Error while saving locations order!");
        };

        let order = startPoints.map(item => (item.id));

        R.handle(R.location.editOrder, order, onSuccess, onFailure);
    }

    const onCreate = () => {
        region = regions.find(x => x.id == regionId);
        editId = 0;
    }

    const onEdit = (item) => {
        editId = item.id;
    }

    const onEditRegion = () => {
        editId = regionId;
    }

    const closeEdit = (obj) => {
        editId = null;

        if (obj) {
            if (obj.level == 0) {
                // update regions
                let item = regions.find(x => x.id == obj.id);
                if (item) {
                    copyObjectData(obj, item, true);
                    regions = regions;
                }
                return;
            }

            // update locations
            let item = locations.find(x => x.id == obj.id);
            if (item) {
                copyObjectData(obj, item);
                locations = locations;
            } else {
                locations = [obj, ...locations];
            }

            if (obj.is_start_point == 1) {
                // update start points
                let item = startPoints.find(x => x.id == obj.id);
                if (item) {
                    copyObjectData(obj, item, true);
                    startPoints = startPoints;
                } else {
                    startPoints = [obj, ...startPoints];
                }
            } else {
                startPoints = startPoints.filter(x => x.id != obj.id);
            }

        }
    }

    const onDelete = (obj) => {
        if (obj.hotel_id > 0) {
            Alert.warning("Delete location", "This is a hotel owned by an account!\nYou can not delete this location.");
            return;
        }
        Alert.delete("Delete location", `You are about to delete location "${obj.name}".\nAre you sure?`, () => deleteLocation(obj.id));
    }

    const deleteLocation = (id) => {

        const onSuccess = result => {
            startPoints = startPoints.filter(x => x.id != id);
            locations = locations.filter(x => x.id != id);
            Notifier.showMessage("Location deleted");
        }

        const onFailure = err => {
            if (err.code === 'not_allowed') {
                if (err.params === "hotel") {
                    Alert.warning("Delete location", "This is a hotel owned by an account!\nYou can not delete this location.");
                    return;
                }
            }

            if (err.code === 'object_related') {
                let message = [];

                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });

                Alert.warning("Delete location", `This location is associated with ${message.join(", ")}.\nYou can not delete this location.`);
            }
        };

        R.handle(R.location.delete, id, onSuccess, onFailure);
    }


    const openLocalPrices = (location) => {
        console.log("openLocalPrices", location);
        localLocation = copyObject(location);
    }

    const closeLocalPrices = () => {
        localLocation = null;
    }


    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = startPoints;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        startPoints = newTracklist;
        hovering = null;
        saveOrder();
    }


    load();
</script>

<PageHeader title="Locations" controls={ pageHeaderControls } on:create="{ onCreate }" on:reload="{ load }"/>

{#if initialized}
    <div class="row">
        <div class="col-xl-4">
            <div class="panel panel-default">
                <div class="panel-heading">
                    Locations
                </div>
                <div class="panel-body panel-pad">
                    <div class="tools-box">
                        <select class="form-select" bind:value="{ regionId }">
                            <option value="0">all regions</option>
                            {#each regions as region}
                                <option value="{ region.id}">{ region.name }</option>
                            {/each}
                        </select>
                        <button class="btn btn-default btn-flex line-height-1 ms-1" title="edit region"
                                disabled="{ regionId == 0 }"
                                on:click="{ onEditRegion }">
                            <AppIcon icon="edit" size="16"/>
                        </button>
                    </div>
                </div>
                <table class="table table-list locations">
                    <tbody>
                    {#each locations as item}
                        {#if regionId == 0 || item.parent_id == regionId}
                            <tr class="row-hover">
                                <td class="name">
                                    <LocationIcon name="{ item.type_id }" size="14" cssClass="me-2"/>
                                    <div class="is-link" class:not-active={ item.is_active < 1}
                                         on:click="{ () => onEdit(item) }">
                                        { item.name }
                                    </div>
                                </td>
                                <td class="code text-gray">
                                    { item.code }
                                </td>
                                <td class="button-column">
                                    {#if item.is_local == 1}
                                        <div class="pointer" title="set local taxi prices"
                                             on:click={ () => openLocalPrices(item) }>
                                            <AppIcon icon="euro-solid" size="16"/>
                                        </div>
                                    {/if}
                                </td>
                                <td class="button-column pointer" on:click="{ () => onDelete(item) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            </tr>
                        {/if}
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-xl-4">
            {#if localLocation == null}
                <div class="panel panel-default">
                    <div class="panel-heading">
                        Starting points
                    </div>
                    <table class="table table-list start-points">
                        <tbody>
                        {#each startPoints as item, index (item.id)}
                            <tr class="row-hover" animate:flip="{{ duration: 100 }}"
                                draggable={true}
                                on:dragstart={event => dragstart(event, index)}
                                on:drop|preventDefault={event => drop(event, index)}
                                ondragover="return false"
                                on:dragenter={() => hovering = index}
                                class:is-active={hovering === index}
                            >
                                <td class="name">
                                    <div class="small">{ item.parent_name }</div>
                                    <div class="is-link" class:not-active={ item.is_active < 1}
                                         on:click="{ () => onEdit(item) }">
                                        { item.name }
                                    </div>
                                </td>
                                <td class="code text-gray">
                                    { item.code }
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                </div>
            {:else}
                <LocationLocalPrices bind:location={ localLocation } {locations}/>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <LocationModal locationId="{ editId }" parent="{ region }" {regions} closeCallback="{ closeEdit }"/>
{/if}

<style>
    .start-points tr.is-active {
        background-color: #e4eaee;
    }

    .start-points tr > td.code {
        width: 60px;
    }

    .locations tr > td.name {
        display: flex;
        align-items: center;
    }

    :global(.locations tr>td.name .location-icon) {
        color: #ccc;
    }

    .start-points tr > td.code, .locations tr > td.code {
        width: 60px;
    }
</style>